module.exports = __webpack_public_path__ + "static/media/daviddwinger.e810ebf2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/daviddwinger.webp
// module id = 441
// module chunks = 0